module.exports = function() {
	$('.carousel').carousel({
	  interval: 3000
	})
};


// WEBPACK FOOTER //
// ./js/plugins/carousel.js